module.exports = __webpack_public_path__ + "img/education.30a33a70.svg";